import React from 'react';
import { useSelector } from 'react-redux';
import { getCreditScoreHistoryState } from 'selectors/getCreditScoreHistory';
import CreditScoreGauge from 'components/CreditScoreGauge';
import { CreditScoreSource } from 'api/ReportsApi';

import styles from './CreditScoreSection.module.scss';

const CreditScoreSection: React.FC = () => {
  const history = useSelector(getCreditScoreHistoryState);

  if (!history || history.length === 0) return null;

  const efxHistory = history.filter((entry) => entry.source === CreditScoreSource.Equifax);

  const sortedHistory = [...efxHistory].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  if (sortedHistory.length === 0) return null;
  const latestScore = sortedHistory[0].score;
  const previousScore = sortedHistory[1]?.score;
  const change = previousScore ? latestScore - previousScore : 0;

  return (
    <div className={styles.section}>
      <p className={styles.sectionLabel}>Your estimated credit score.</p>
      <CreditScoreGauge score={latestScore} change={change} />
    </div>
  );
};

export default CreditScoreSection;
